import React, { useState } from "react";
import "./styles/welcome.scss";
import { ReactComponent as Logo } from "./images/Dr.Drat_Suite.svg";
import { ReactComponent as Arrow } from "./images/icon_arrow_forward.svg";
import { ReactComponent as IconDevelopers } from "./images/icon_developers.svg";
import { ReactComponent as IconIDE } from "./images/icon_ide.svg";
import { ReactComponent as IconForum } from "./images/icon_forum.svg";
import { ReactComponent as IconStore } from "./images/icon_store.svg";
import { ReactComponent as EcoSystemWorks } from "./images/ecosystem_works.svg";
import { ReactComponent as EcoSystemWorks_ko } from "./images/ecosystem_works_ko.svg";
import { ReactComponent as IconCopy } from "./images/icon_copy.svg";
import { useTranslation } from "react-i18next";
import i18n from "./i18n";

export function WelcomePage() {
    const { t } = useTranslation();
    const [isLanguageMenuOpen, setLanguageMenuOpen] = useState<boolean>(false);
    const changeLanguage = (lang: string) => {
        i18n.changeLanguage(lang);
        setLanguageMenuOpen(false);
    };
    const [isActive, setIsActive] = useState("");
    const handleCopyClipBoard = async (text: string) => {
        await navigator.clipboard.writeText(text);
    };
    return (
        <div className={"welcome-container"}>
            <header className={"welcome-header"}>
                <ul className={"top-nav"}>
                    <li className={isActive ? "": "active"}>
                        <button onClick={()=> {
                            setIsActive("");
                            changeLanguage("en")
                        }}>{t("en")}</button>
                    </li>
                    <li className={!isActive ? "": "active"}>
                        <button onClick={()=> {
                            setIsActive("active");
                            changeLanguage("ko")
                        }}>{t("ko")}</button>
                    </li>
                </ul>
                <h1 className={"logo"}>
                    <Logo aria-label={"Dr.Dart-suite"}/>
                </h1>
            </header>
            <main className={"welcome-main"}>
                <section className={"greetings"}>
                    <p className={"title"}>{t("greetings-title")}</p>
                    <p>{t("greetings-desc")}</p>
                </section>
                <section className={"link-cards"}>
                    <div className={"card type-1"}>
                        <div className={"card-inner"}>
                            <h2 className={"card-title"}>Dr.Dart-Platform</h2>
                            <p className={"card-desc"}>{t("card-desc_1")}</p>
                            <a href={"https://developers.drdart.io/guide/ver/pub/quick-install-guide"} target={"_blank"} className={"btn-download"}>{t("btn-download")} <Arrow /></a>
                        </div>
                    </div>
                    <div className={"cards-box"}>
                        <div className={"card type-2"}>
                            <div className={"card-inner"}>
                                <div className={"card-icon"}>
                                    <IconDevelopers />
                                </div>
                                <h2 className={"card-title"}>Dr.Dart-Developers</h2>
                                <p className={"card-desc"}>{t("card-desc_2")}</p>
                            </div>
                            <a href={"https://developers.drdart.io/"} target={"_blank"} className={"btn-link"}><span>{t("go-to-site")}</span> <Arrow /></a>
                        </div>
                        <div className={"card type-3"}>
                            <div className={"card-inner"}>
                                <div className={"card-icon"}>
                                    <IconIDE />
                                    <p className={"card-tooltip"}>{t("browser-desc")}</p>
                                </div>
                                <h2 className={"card-title"}>Dr.Dart-IDE</h2>
                                <p className={"card-desc"}>{t("card-desc_3")}</p>
                            </div>
                            <a href={"https://ide.drdart.io/"} target={"_blank"} className={"btn-link"}><span>{t("go-to-site")}</span> <Arrow /></a>
                        </div>
                        <div className={"card type-4"}>
                            <div className={"card-inner"}>
                                <div className={"card-icon"}>
                                    <IconForum />
                                </div>
                                <h2 className={"card-title"}>Dr.Dart-Forum</h2>
                                <p className={"card-desc"}>{t("card-desc_4")}</p>
                            </div>
                            <a href={"https://forum.drdart.io/login"} target={"_blank"} className={"btn-link"}><span>{t("go-to-site")}</span> <Arrow /></a>
                        </div>
                        <div className={"card type-5"}>
                            <div className={"card-inner"}>
                                <div className={"card-icon"}>
                                    <IconStore />
                                </div>
                                <h2 className={"card-title"}>Dr.Dart-Store</h2>
                                <p className={"card-desc"}>{t("card-desc_5")}</p>
                            </div>
                            <a href={"https://store.drdart.io"} target={"_blank"} className={"btn-link"}><span>{t("go-to-site")}</span> <Arrow /></a>
                        </div>
                    </div>
                </section>
                <section className={"info-groups"}>
                    <h3 className={"title"}>{t("group-title_1")}</h3>
                    <p className={"desc"}>{t("group-desc_1")}</p>
                    <div className={"link-box"}>
                        <a href={"https://developers.drdart.io/guide/ver/pub/beginner-user-guides"} target={"_blank"}>{t("btn-guide_1")}</a>
                        <a href={"https://developers.drdart.io/guide/ver/pub/advanced-user-guides"} target={"_blank"}>{t("btn-guide_2")}</a>
                    </div>
                </section>
                <section className={"info-groups"}>
                    <h3 className={"title"}>{t("group-title_2")}</h3>
                    <figure className={isActive ? "svg-img" : "svg-img on"}><EcoSystemWorks /></figure>
                    <figure className={!isActive ? "svg-img" : "svg-img on"}><EcoSystemWorks_ko /></figure>
                </section>
                <section className={"info-groups"}>
                    <div className={"info-inner"}>
                        <h3 className={"title"}>{t("group-title_3")}</h3>
                        <div className={"desc-inner"}>
                            <p className={"desc"}>{t("group-desc_3")}</p>
                            <span className={"copy-box"}>
                                <a className={"mail-to"} href="mailto:dart@doosan.com">dart@doosan.com</a>
                                <button className={"copy"} onClick={() => { handleCopyClipBoard('dart@doosan.com') }}><IconCopy /></button>
                            </span>
                        </div>
                    </div>
                </section>
            </main>
            <footer className={"welcome-footer"}>
                <address>Copyright © 2023 Doosan Robotics. All Rights Reserved.</address>
            </footer>
            <div className="bottom-banner">
                <span className="banner-txt">{t("banner-txt")}</span>
                <a href={"https://developers.drdart.io/guide/ver/pub/quick-install-guide"} target={"_blank"} className="banner-link">{t("try-it")}</a>
            </div>
        </div>
    )
}